// import "./style.scss";
import getConfig from 'next/config';
import BayanModal from '../../../utils/modal';
import React, { useState } from 'react';

function Testimonials(props) {

	const [showVideo, setShowVideo] = useState(false);
	const [videoID, setVideoID] = useState('');

	const handleVideoSpreaming = (id) => {
		setVideoID(id);
		setShowVideo(true);
	}

	const closeModal = () => {
		setVideoID('');
		setShowVideo(false);
	}

	return (
		<>
			{showVideo && <BayanModal videoID={videoID} theme={props.theme} closeModal={closeModal} />}
			<div className="bayan-faculty blue-bg mobile-view">
				<h1 className="text-center headingF headingF-sm">Hear From Current Bayan Students and Alumni</h1>
				<div className="container">
						{
							props.testimonies.map((testimony) => {
								return <div key={testimony.name} onClick={() => handleVideoSpreaming(testimony.id)}>
									<img src={testimony.thumbnail} alt={testimony.name} />
									<h1>{testimony.name}</h1>
									<p>{testimony.education}</p>
									<p>{testimony.classYear}</p>
								</div>
							})
						}
				</div>
			</div>

		</>
	);
}

export default Testimonials;
